import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FAQSection = () => {
  const { t } = useTranslation();

  const faqs = [
    {
      question: t('faq.questions.audioFormats.question'),
      answer: t('faq.questions.audioFormats.answer'),
    },
    {
      question: t('faq.questions.devices.question'),
      answer: t('faq.questions.devices.answer'),
    },
    {
      question: t('faq.questions.voiceMemos.question'),
      answer: t('faq.questions.voiceMemos.answer'),
    },
    {
      question: t('faq.questions.privacy.question'),
      answer: t('faq.questions.privacy.answer'),
    },
    {
      question: t('faq.questions.languages.question'),
      answer: t('faq.questions.languages.answer'),
    },
  ];

  const leftFaqs = faqs.slice(0, 3);
  const rightFaqs = faqs.slice(3);

  return (
    <div className="py-24 bg-white dark:bg-slate-900">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4 dark:text-white">
            {t('faq.title')}
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto dark:text-gray-400">
            {t('faq.subtitle', 'Have questions about Notely? Find answers below.')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16">
          <Accordion type="single" collapsible defaultValue="item-0">
            {leftFaqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-transparent border-b border-gray-200 px-0 dark:border-slate-700"
              >
                <AccordionTrigger className="text-gray-900 font-medium hover:no-underline text-left dark:text-gray-100">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-500 dark:text-gray-400">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <Accordion type="single" collapsible>
            {rightFaqs.map((faq, index) => (
              <AccordionItem
                key={index + 3}
                value={`item-${index + 3}`}
                className="bg-transparent border-b border-gray-200 px-0 dark:border-slate-700"
              >
                <AccordionTrigger className="text-gray-900 font-medium hover:no-underline text-left dark:text-gray-100">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-500 dark:text-gray-400">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="text-center mt-12 text-gray-500 dark:text-gray-400">
          {t('faq.moreQuestions')}{' '}
          <a href="/contact" className="text-primary hover:text-primary/90">
            {t('faq.contactSupport')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
